import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../api/client';

/** Simple brand marks (inline SVG, no extra deps). */
const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
    <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09L2.18 7.07C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.86-3c-1.01.68-2.31 1.08-3.42 1.08-2.86 0-5.29-1.93-6.16-4.53l-3.66 2.84C3.99 20.53 7.7 23 12 23z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="#1877F2" aria-hidden="true">
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047v-2.66c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97H15.83c-1.491 0-1.956.93-1.956 1.886v2.265h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);

/**
 * Google + Facebook login buttons. Rendered only when the corresponding
 * admin toggle (app_settings) is ON — email/password login stays untouched.
 */
export const SocialLoginButtons = () => {
  const { t } = useTranslation('auth');
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get('/auth/social-config').then(({ data }) => setCfg(data)).catch(() => setCfg(null));
  }, []);

  if (!cfg || (!cfg.google_enabled && !cfg.facebook_enabled)) return null;

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/social/complete';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const handleFacebook = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/facebook/login`;
  };

  return (
    <div className="mt-4 flex w-full flex-col gap-2" data-testid="social-login-buttons">
      {cfg.google_enabled && (
        <button
          type="button"
          onClick={handleGoogle}
          className="flex h-9 w-full items-center justify-center gap-2 rounded-md border border-border bg-background text-xs font-semibold transition-colors hover:bg-secondary"
          data-testid="social-login-google-btn"
        >
          <GoogleIcon /> {t('social.continue_google')}
        </button>
      )}
      {cfg.facebook_enabled && (
        <button
          type="button"
          onClick={handleFacebook}
          className="flex h-9 w-full items-center justify-center gap-2 rounded-md border border-border bg-background text-xs font-semibold transition-colors hover:bg-secondary"
          data-testid="social-login-facebook-btn"
        >
          <FacebookIcon /> {t('social.continue_facebook')}
        </button>
      )}
    </div>
  );
};

export default SocialLoginButtons;
